/** 1.8.5: small words the Tech Support screens share. */
import { clockWithPeriod } from '@shared/dayplan';
import { serviceMinutesNow } from '@shared/dates';

/** "10:05 AM" on the building's clock for an ISO instant. */
export const formatClockWords = (iso: string, lang: string = 'en'): string => clockWithPeriod(serviceMinutesNow(new Date(iso)), lang === 'es' ? 'es' : 'en');
